
var service = {};

var token = JSON.stringify(localStorage.getItem('userToken'));
var userData = JSON.stringify(localStorage.getItem('user'));

export var setUserData=(user)=>{
    return userData =user;
}

export var getUserData=()=>{
    return userData;
}

export var setToken=(tokenData)=>{
    return token = tokenData;
}

export var getToken=()=>{
    return token;
}
export default service;